module.exports = __webpack_public_path__ + "static/media/YF05_4.474e5024.jpg";